















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

export interface Sequence {
  [index: string]: string
}

@Component
export default class Indicator extends Vue {
  @Prop()
  sequences: Sequence | string[]

  @Prop()
  currentIndex: string | number

  /**
   * シーケンスの表現として多様なデータ構造を利用できるよう、
   * 配列の他にkey-value構造も渡せるように変更した。
   *
   * そのため、indexにあたる値の型が数値とは限らなくなったので、
   * 全てStringにキャストして比較に使うよう実装.
   */
  isCurrent(index: string) {
    return {
      current: String(this.currentIndex) === index,
    }
  }
}
